import { createSlice } from '../../../_reusable/ScanAppAndReportStates/ActionPlanChangeNotesV2';

const SLICE = createSlice({ prop: 'actionPlanChangeNotes', arrAncestorProps: ['app'] });

export default SLICE;